exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-store-welcome-container[data-v-f8b56f9e]{display:flex;flex-direction:column;justify-content:center;align-items:center;padding-top:2em}.new-store-welcome-container .title[data-v-f8b56f9e]{text-shadow:1px 1px 2px #ddd;margin-bottom:0}.new-store-welcome-container .new-features-message[data-v-f8b56f9e]{padding-bottom:1em}.new-store-welcome-container .new-features-message .feature[data-v-f8b56f9e]{list-style-type:disc;color:#ec1c24;text-shadow:1px 1px 2px #ddd}@media (max-width:1088px){.new-store-welcome-container[data-v-f8b56f9e]{padding-top:4em}.new-store-welcome-container .new-features-message[data-v-f8b56f9e]{max-width:80vw}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f8b56f9e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/landing/NewStoreWelcome.vue
// module id = hzNq
// module chunks = 18